import { useEffect } from 'react';
import { MouseData } from '../types/hooks';
import { LauncherElementTypeName } from '../types/launcherElement';
import { useMouse } from './useEditor';

export const mouseCoreHooks = () => {
  const [mouse, setMouse] = useMouse<MouseData>();

  const handleMouseMove = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const hoveredElementType = target.getAttribute(
      'element-type'
    ) as LauncherElementTypeName;
    const hoveredElementID = hoveredElementType ? target.id : null;

    setMouse({
      pos: { x: e.clientX, y: e.clientY },
      movement: { x: e.movementX, y: e.movementY },

      hoveredElementType,
      hoveredElementID,

      targetID: target.id || null,

      isDragging: mouse.isDown ? true : false,
    });
  };
  const handleMouseDown = (e: MouseEvent) =>
    setMouse({ isDown: true, button: e.button });
  const handleMouseUp = (e: MouseEvent) =>
    setMouse({ isDown: false, button: e.button });

  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault();
  };

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  });
};
